import React from "react";
import { useDropzone } from "react-dropzone";
import { Grid, FormLabel } from "@mui/material";
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  dropzone: {
    adding: "20px",
    height: "200px",
    border: "3px dashed #4050b5",
    outline: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dropzoneActive: {
    adding: "20px",
    height: "200px",
    outline: "none",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid #4050b5",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
});
const Dropzone = ({ onDrop, accept, classes }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
  });
  return (
    <Grid
      className={isDragActive ? classes.dropzoneActive : classes.dropzone}
      {...getRootProps()}
    >
      <input className="dropzone-input" {...getInputProps()} />
      <Grid>
        {isDragActive ? (
          <FormLabel>Release to drop the files here</FormLabel>
        ) : (
          <FormLabel>
            Drag and drop some files here, or click to select files
          </FormLabel>
        )}
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(Dropzone);
